module.exports = __webpack_public_path__ + "static/media/elaborated-white.6f99e2aa.svg";